import "./Navbar.scss";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [largeur, setLargeur] = useState(window.innerWidth);

  const toggleNav = () => {
    setToggleMenu(!toggleMenu);
  };

  useEffect(() => {
    const changeWidth = () => {
      setLargeur(window.innerWidth);
    };

    window.addEventListener("resize", changeWidth);

    return () => {
      window.removeEventListener("resize", changeWidth);
    };
  }, []);

  return (
    <nav>
      {(toggleMenu || largeur > 500) && (
        <ul className="liste">
          <li className="items">
            <NavLink className="nav-link" to="/">Accueil</NavLink>
          </li>
          <li className="items">
            <NavLink className="nav-link" to="/write">Écrire</NavLink>
          </li>
          <li className="items">
            <NavLink className="nav-link" to="/contact">Contact</NavLink>
          </li>
        </ul>
      )}
      <i className="fas fa-bars" onClick={toggleNav}></i>
    </nav>
  );
}
